import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomerProfile from "../../callsModule/common/TabProfile";
import CustomerDataset from "../../callsModule/common/TabDataset";
import CustomerNotes from "../../callsModule/common/TabNotes";
 
import CustomerHistory from "../../callsModule/common/TabHistory";
import CustomerCallsHistory from "../../callsModule/common/TabCallsHistory";
import CustomerChats from "../../callsModule/common/TabChats";
import CustomerTexts from "../../callsModule/common/TabTexts";
import CustomerEmails from "../../callsModule/common/TabEmails";
import SendEmail from "../../callsModule/common/SendEmail";
import SendText from "../../callsModule/common/SendText";
import AddRelatedRecord from "../../callsModule/common/AddRelatedRecord";
import { PAYMENT_STRINGS } from "../../../common/constants/customerModule/paymentConstants";
import CustomerOptIn from "../../callsModule/common/TabOptin";
import { getcustomerprofilebyguid } from "../../../services/customerinfoModule/profileServices";
import PaymentConfirmModal from "../../customerModule/payments/PaymentConfirmModal";
import Promises from "../promises/Promises";
import Payments from "../../customerModule/payments/Payments";
import CustomerPromises from "../../callsModule/common/TabPromises";
import CustomerDataUpload from "../../callsModule/common/TabDataUpload";
//import TabConversation from "../../callsModule/common/TabConversation";

const tabConfig = (customerguid) => [
  //{ label: "Conversation", value: "Conversation", component: <TabConversation customerguid={customerguid} />     },
  {
    label: "Profile",
    value: "Profile",
    component: (
      <CustomerProfile agentType={"Customer"} customerguid={customerguid} />
    ),
  },
 
  {
    label: "Dataset",
    value: "Dataset",
    component: <CustomerDataset customerguid={customerguid} />,
  },
  {
    label: "Notes",
    value: "Notes",
    component: <CustomerNotes customerguid={customerguid} />,
  },
  {
    label: "Payments",
    value: "Payments",
    component: <Payments customerguid={customerguid} isDash={true} />,
  },
  {
    label: "Promises",
    value: "Promises",
    component: <CustomerPromises customerguid={customerguid} isDash={true} />,
  },
  {
    label: "Data Upload",
    value: "DataUpload",
    component: <CustomerDataUpload customerguid={customerguid} isDash={true} />,
  },
  {
    label: "History",
    value: "History",
    component: <CustomerHistory customerguid={customerguid} />,
  },
  {
    label: "Calls",
    value: "Calls",
    component: <CustomerCallsHistory customerguid={customerguid} isDash={true} />,
  },
  {
    label: "Chats",
    value: "Chats",
    component: <CustomerChats customerguid={customerguid} isDash={true} />,
  },
  {
    label: "Texts",
    value: "Texts",
    component: <CustomerTexts customerguid={customerguid} isDash={true} />,
  },
  {
    label: "Emails",
    value: "Emails",
    component: <CustomerEmails customerguid={customerguid} isDash={true} />,
  },
   {
    label: "OptIn",
    value: "OptIn",
    component: <CustomerOptIn customerguid={customerguid} />,
  },
];

const CustomerDashInfo = ({ customerguid, onBack, menuActions = [] }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState("Profile");
  const [localCustomerGuid, setLocalCustomerGuid] = useState(customerguid);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const tabs = tabConfig(customerguid);
  const renderTabContent = () => {
    const current = tabs.find((tab) => tab.value === currentTab);
    return current?.component || null;
  };
  useEffect(() => {
    setLocalCustomerGuid(customerguid);
  }, [customerguid]);

  useEffect(() => {
    let mounted = true;
    const fetchProfile = async () => {
      setLoading(true);
      try {
        const data = await getcustomerprofilebyguid({ customerguid: localCustomerGuid });
        if (mounted) setProfile(data?.[0] || null);
      } catch (error) {
        console.error("Error fetching profile:", error);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (localCustomerGuid) {
      fetchProfile();
    }

    return () => {
      mounted = false;
    };
  }, [localCustomerGuid]);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [paymentModalMode, setPaymentModalMode] = useState('now');
  const openPaymentModal = (mode) => {
    setPaymentModalMode(mode);
    setPaymentModalOpen(true);
    handleMenuClose();
  };
  if (!customerguid) return null;
  return (
    <Box sx={{ p: 2 }}>
      {!loading && (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 2,
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={onBack} sx={{ mr: 1 }} aria-label="back">
                <ArrowCircleLeftOutlinedIcon />
              </IconButton>
              <Typography variant="h6">
                {profile && `${profile.firstname} ${profile.lastname}`}
              </Typography>
            </Box>
           
          </Box>
          <Tabs
            value={currentTab}
            onChange={(e, val) => setCurrentTab(val)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ mb: 2 }}
          >
            {tabs.map((tab) => (
              <Tab key={tab.value} label={tab.label} value={tab.value} />
            ))}
          </Tabs>
        </>
      )}
      <Box>{renderTabContent()}</Box>
      {paymentModalOpen && (
        <PaymentConfirmModal
          open={paymentModalOpen}
          onClose={() => setPaymentModalOpen(false)}
          selectedGuid={localCustomerGuid}
          mode={paymentModalMode}
        />
      )}
    </Box>
  );
};

export default CustomerDashInfo;
